define('page/zhixin', [
    'bangmai-form',
    'log',
    'common/util',
    'common/bargain',
    'widget/recommend-car-list',
], (bangmai, log, util, bargain, recommendCarList) => ({
    init() {
        bangmai.init({
            target: '#js-main-bangmai',
            dialog: '#js-success-modal-common',
            fancySelect: true,
        });
        log.push(['_trackEvent', 'zhixin_bangmai_form_show', '', '']);
        bargain.initCarListBargain();
        recommendCarList.init();
    },
}));
/* istanbul ignore if */
if (typeof window.__karma__ === 'undefined') {
    require(['page/zhixin'], page => {
        page.init();
    });
}
